import { createRouter, createWebHashHistory } from 'vue-router';
import { routes } from './routes';

/**
 * 使用 hash 模式：桌面外壳以 file:// 加载时同样可用，
 * 与对标产品的行为保持一致。
 */
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
